import { render } from "./BestTV.vue?vue&type=template&id=60a94743&scoped=true"
import script from "./BestTV.vue?vue&type=script&lang=js"
export * from "./BestTV.vue?vue&type=script&lang=js"

import "./BestTV.vue?vue&type=style&index=0&id=60a94743&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60a94743"]])

export default __exports__